import React, { useState, useEffect } from 'react';
import {
  formatPrice,
  LoadingGrid,
  TableList,
} from '../../../../../rbts/helpers';
import { useMovimientosTicket, useWalletUsersByNombre, WalletUserMatch } from '../hooks/MovimientosHook';

type SearchType = 'folio' | 'nombre';

type Props = {};
const Vista: React.FC<Props> = ({}) => {
  const [searchType, setSearchType] = useState<SearchType>('folio');
  const [searchValue, setSearchValue] = useState('');

  // Folio search
  const [folioParaBuscar, setFolioParaBuscar] = useState('');
  const [reloadMovimientos, setReloadMovimientos] = useState(Math.random() * 40);
  const { list, loadingRequest: loadingMovimientos } = useMovimientosTicket(reloadMovimientos, folioParaBuscar);

  // Nombre search
  const [nombreParaBuscar, setNombreParaBuscar] = useState('');
  const [reloadNombre, setReloadNombre] = useState(Math.random() * 40);
  const { matches, loadingRequest: loadingNombre } = useWalletUsersByNombre(reloadNombre, nombreParaBuscar);

  // Nombre seleccionado para mostrar info en la tabla de movimientos
  const [selectedUserName, setSelectedUserName] = useState('');

  const loadingRequest = loadingMovimientos || loadingNombre;

  // Auto-seleccionar si solo hay un resultado
  useEffect(() => {
    if (matches.length === 1 && matches[0].folio) {
      setSelectedUserName(matches[0].nombre);
      setFolioParaBuscar(matches[0].folio);
      setReloadMovimientos(Math.random() * 40);
    }
  }, [matches]);

  const handleToggle = (type: SearchType) => {
    if (type === searchType) return;
    setSearchType(type);
    setSearchValue('');
    setFolioParaBuscar('');
    setSelectedUserName('');
    setNombreParaBuscar('');
    setReloadNombre(Math.random() * 40);
    setReloadMovimientos(Math.random() * 40);
  };

  const handleBuscar = () => {
    const value = searchValue.trim();
    if (!value) return;
    if (searchType === 'folio') {
      setFolioParaBuscar(value);
      setReloadMovimientos(Math.random() * 40);
    } else {
      setFolioParaBuscar('');
      setSelectedUserName('');
      setReloadMovimientos(Math.random() * 40);
      setNombreParaBuscar(value);
      setReloadNombre(Math.random() * 40);
    }
  };

  const handleSelectUser = (match: WalletUserMatch) => {
    if (!match.folio) return;
    setSelectedUserName(match.nombre);
    setFolioParaBuscar(match.folio);
    setReloadMovimientos(Math.random() * 40);
  };

  const columns: any = [
    {
      id: 'ticket_folio',
      name: <div className="fw-bolder text-muted me-5">Folio</div>,
      selector: (row: any) => row.folio,
      cell: (row: any) => (
        <>
          <span>{row.folio}</span>
        </>
      ),
      sortable: false,
    },
    {
      id: 'fecha',
      name: <div className="fw-bolder text-muted me-5">Día administrativo</div>,
      selector: (row: any) => row.fecha,
      cell: (row: any) => (
        <>
          <span>{row.fecha}</span>
        </>
      ),
      sortable: true,
    },
    {
      id: 'punto_venta_nombre',
      name: <div className="fw-bolder text-muted me-5">Punto de venta</div>,
      selector: (row: any) => row.punto_venta_nombre,
      cell: (row: any) => (
        <>
          <span>{row.punto_venta_nombre}</span>
        </>
      ),
      sortable: true,
    },
    {
      id: 'producto_nombre',
      name: <div className="fw-bolder text-muted me-5">Producto</div>,
      selector: (row: any) => row.producto_nombre,
      cell: (row: any) => (
        <>
          <span>{row.producto_nombre}</span>
        </>
      ),
      sortable: true,
    },
    {
      id: 'cantidad',
      name: <div className="fw-bolder text-muted me-5 ">Cantidad</div>,
      selector: (row: any) => row.cantidad,
      cell: (row: any) => (
        <>
          <div className="fw-bolder">{row.cantidad}</div>
        </>
      ),
      sortable: false,
    },
    {
      id: 'costo_total',
      name: <div className="fw-bolder text-muted me-5 ">Costo total</div>,
      selector: (row: any) => row.costo_total,
      cell: (row: any) => (
        <>
          <div className="fw-bolder">
            {formatPrice(
              row.costo_total ? row.costo_total : 0,
              'es-MX',
              'MXN',
              2,
              2
            )}
          </div>
        </>
      ),
      sortable: false,
    },
  ];

  const showMatchList = searchType === 'nombre' && matches.length > 1 && !folioParaBuscar;
  const showNoResults = searchType === 'nombre' && nombreParaBuscar !== '' && matches.length === 0 && !loadingNombre && !folioParaBuscar;

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="col-xl-12">
          <div className="card mb-6 mb-xl-9">
            <div className="card-header border-0 pt-5">
              <div className="card-title">
                <div className="w-500px pe-5 fs-7 text-gray-700">

                  {/* Toggle Folio / Nombre */}
                  <div className="w-100 d-flex mb-3">
                    <div className="btn-group" role="group">
                      <button
                        type="button"
                        onClick={() => handleToggle('folio')}
                        className={`btn btn-sm ${searchType === 'folio' ? 'btn-primary' : 'btn-light-primary'}`}
                      >
                        Folio
                      </button>
                      <button
                        type="button"
                        onClick={() => handleToggle('nombre')}
                        className={`btn btn-sm ${searchType === 'nombre' ? 'btn-primary' : 'btn-light-primary'}`}
                      >
                        Nombre
                      </button>
                    </div>
                  </div>

                  <div className="w-100 d-flex">
                    <label className="required form-label w-auto">
                      {searchType === 'folio' ? 'Ticketcash:' : 'Nombre del titular:'}
                    </label>
                  </div>

                  <div className="w-100 d-flex">
                    <input
                      type="text"
                      placeholder={
                        searchType === 'folio'
                          ? 'Ingrese folio del ticketcash'
                          : 'Ingrese nombre del titular'
                      }
                      value={searchValue}
                      maxLength={searchType === 'folio' ? 30 : 100}
                      onChange={(e) => setSearchValue(e.target.value)}
                      className="form-control w-300px"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') handleBuscar();
                      }}
                    />
                    <button
                      type="button"
                      title="Buscar"
                      onClick={handleBuscar}
                      className="btn btn-primary w-200px ms-5"
                      disabled={loadingRequest}
                    >
                      {!loadingRequest && (
                        <span className="indicator-label">Buscar</span>
                      )}
                      {loadingRequest && (
                        <span
                          className="indicator-progress"
                          style={{ display: 'block' }}
                        >
                          Espere por favor
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-toolbar">
                <div className="d-flex rounded mt-3"></div>
              </div>
            </div>

            <div className="card-body">
              <div className="row gy-5 g-xl-8">
                <div className="col-xl-12">
                  {loadingRequest ? (
                    <LoadingGrid text="Cargando..."></LoadingGrid>
                  ) : (
                    <>
                      {/* Lista de titulares cuando hay múltiples coincidencias */}
                      {showMatchList && (
                        <div className="mb-6">
                          <p className="fs-6 text-gray-700 fw-bold mb-3">
                            Se encontraron {matches.length} titulares. Seleccione uno:
                          </p>
                          <div className="table-responsive">
                            <table className="table table-hover table-row-bordered align-middle gs-0 gy-3">
                              <thead>
                                <tr className="fw-bolder text-muted border-bottom">
                                  <th>Nombre</th>
                                  <th>Email</th>
                                  <th>Folio</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {matches.map((m) => (
                                  <tr key={m.id}>
                                    <td>{m.nombre}</td>
                                    <td>{m.email}</td>
                                    <td>{m.folio || '-'}</td>
                                    <td>
                                      <button
                                        className="btn btn-sm btn-light-primary"
                                        onClick={() => handleSelectUser(m)}
                                        disabled={!m.folio}
                                      >
                                        Ver movimientos
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}

                      {/* Sin resultados */}
                      {showNoResults && (
                        <p className="text-muted fs-6">
                          No se encontraron titulares con ese nombre.
                        </p>
                      )}

                      {/* Info del titular seleccionado por nombre */}
                      {searchType === 'nombre' && folioParaBuscar && selectedUserName && (
                        <div className="mb-3 fs-6 text-gray-700">
                          Titular:{' '}
                          <span className="fw-bold">{selectedUserName}</span>
                          {' — '}Folio:{' '}
                          <span className="fw-bold">{folioParaBuscar}</span>
                          {matches.length > 1 && (
                            <button
                              className="btn btn-sm btn-link ms-3 p-0"
                              onClick={() => {
                                setFolioParaBuscar('');
                                setSelectedUserName('');
                              }}
                            >
                              ← Volver a resultados
                            </button>
                          )}
                        </div>
                      )}

                      {list.length > 0 && (() => {
                        const totalCantidad = list.reduce((s: number, r: any) => s + (Number(r.cantidad) || 0), 0);
                        const totalCosto    = list.reduce((s: number, r: any) => s + (Number(r.costo_total) || 0), 0);
                        return (
                          <div className="d-flex justify-content-end mb-4">
                            <div className="border rounded px-6 py-3 bg-light-primary d-flex gap-10">
                              <div className="text-center">
                                <div className="text-muted fw-bold fs-8 text-uppercase mb-1">Total cantidad</div>
                                <div className="fw-bolder fs-5 text-dark">{totalCantidad}</div>
                              </div>
                              <div className="text-center">
                                <div className="text-muted fw-bold fs-8 text-uppercase mb-1">Total costo</div>
                                <div className="fw-bolder fs-5 text-primary">{formatPrice(totalCosto, 'es-MX', 'MXN', 2, 2)}</div>
                              </div>
                            </div>
                          </div>
                        );
                      })()}

                      <TableList data={list} columns={columns}></TableList>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { Vista };
